<template>
    <div class="contact-us">
        <!-- 头部区域 -->
        <div class="header">
            <div class="header-left">
                <button class="back-btn" @click="goBack">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="title">联系我们</div>
            </div>
        </div>

        <!-- 主要内容 -->
        <div class="contact-content">
            <!-- 工作时间 -->
            <div class="working-hours">
                <div class="hours-title">工作时间</div>
                <div class="hours-time">早9:30-晚21:30</div>
                <div class="hours-time">有问题请及时反馈</div>
            </div>

            <!-- 二维码 -->
            <div class="qr-section">
                <div class="qr-code">
                    <div class="qr-placeholder">
                        <img style="width: 200px;height: 200px;" src="@/assets/images/lianxi2.png" alt="">
                    </div>
                </div>
                <div class="qr-instruction">(长按识别添加)</div>
            </div>

            <!-- 投诉建议 -->
            <div class="complaint-section">
                <div class="complaint-text">作品引流、平台优化、合作交流都可以咨询</div>
                <!-- <div class="complaint-text">长按识别二维码投诉建议</div> -->
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'ContactUs',
    methods: {
        // 返回上一页
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.contact-us {
    height: 100vh;
    background: #f5f5f5;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 头部样式 */
.header {
    background: linear-gradient(135deg, #42b983, #369870);
    color: white;
    padding: 4px;
    border-radius: 12px;
    margin-bottom: 10px;
    position: sticky;
    top: 0;
    z-index: 100;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.back-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    color: white;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
    width: 20px;
    height: 20px;
}

.title {
    font-size: 18px;
    font-weight: 600;
    color: white;
}

/* 内容区域 */
.contact-content {
    padding: 30px;
    text-align: center;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    flex: 1;
}

/* 主标题 */
.main-title {
    margin-bottom: 40px;
}

.title-green {
    color: #42b983;
    font-size: 32px;
    font-weight: bold;
    font-family: 'Microsoft YaHei', sans-serif;
}

.title-red {
    color: #42b983;
    font-size: 32px;
    font-weight: bold;
    font-family: 'Microsoft YaHei', sans-serif;
}

/* 工作时间 */
.working-hours {
    background: #f8f9fa;
    border: 2px solid #42b983;
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 40px;
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
}

.hours-title {
    color: #42b983;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 500;
}

.hours-time {
    color: #42b983;
    font-size: 20px;
    font-weight: bold;
}

/* 二维码区域 */
.qr-section {
    margin-bottom: 40px;
}

.qr-code {
    width: 200px;
    height: 200px;
    margin: 0 auto 15px;
    background: white;
    border: 2px solid #ddd;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.qr-placeholder {
    width: 180px;
    height: 180px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
}

.qr-placeholder svg {
    width: 120px;
    height: 120px;
}

.qr-instruction {
    color: #333;
    font-size: 14px;
    margin-top: 10px;
}

/* 投诉建议 */
.complaint-section {
    color: #333;
    font-size: 14px;
    line-height: 1.6;
}

.complaint-text {
    margin-bottom: 5px;
    font-size: 16px;
    color: #42b983;
}

/* 移动端优化 */
@media (max-width: 768px) {
    .contact-us {
        padding: 10px;
    }

    .header {
        padding: 4px;
        margin-bottom: 10px;
    }


    .contact-content {
        padding: 20px;
    }

    .main-title {
        margin-bottom: 30px;
    }

    .title-green,
    .title-red {
        font-size: 28px;
    }

    .working-hours {
        padding: 15px;
        margin-bottom: 30px;
    }

    .qr-code {
        width: 180px;
        height: 180px;
    }

    .qr-placeholder {
        width: 160px;
        height: 160px;
    }

    .qr-placeholder svg {
        width: 100px;
        height: 100px;
    }
}
</style>
